import { useState, useMemo } from "react";
import Tooltip from "../../common/Tooltip.jsx";
import DeccaIcon from "./DeccaIcon.jsx";
import groupConversationsByDate from "../../../helpers/deccaHelpers/groupConversationsByDate.js";
import formatConversationTime from "../../../helpers/deccaHelpers/formatConversationTime.js";

const History = ({ conversations, onBack, onNewChat, onOpen, onDelete }) => {
  const [query, setQuery] = useState("");

  const groups = useMemo(() => {
    const filtered = (conversations || []).filter((c) =>
      (c.Title || "").toLowerCase().includes(query.toLowerCase())
    );
    return groupConversationsByDate(filtered);
  }, [conversations, query]);

  return (
    <div className="dz-history dz-view-hist">
      {/* header */}
      <div className="dz-history-header">
        <Tooltip content="Terug naar gesprek" left="-100px" top="-50px" width="25px">
          <button className="dz-ib dz-ib-md" onClick={onBack} aria-label="Terug naar gesprek">
            <DeccaIcon name="back" size={19} />
          </button>
        </Tooltip>
        <span className="dz-history-title">Gesprekken</span>
        <Tooltip content="Nieuw gesprek" left="-100px" top="-50px" width="25px">
          <button className="dz-ib dz-ib-md dz-ib-accent" onClick={onNewChat} aria-label="Nieuw gesprek">
            <DeccaIcon name="compose" size={18} />
          </button>
        </Tooltip>
      </div>

      {/* search */}
      <div className="dz-history-search-wrap">
        <div className="dz-history-search">
          <DeccaIcon name="search" size={16} className="dz-history-search-icon" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Zoek in gesprekken…"
            className="dz-history-search-input"
          />
        </div>
      </div>

      {/* list */}
      <div className="dz-history-list">
        {groups.map((group) => (
          <div key={group.name} className="dz-history-group">
            <div className="dz-history-group-label">{group.name}</div>
            {group.items.map((conversation) => (
              <div
                key={conversation.docid || conversation.ID}
                className="dz-history-row"
                onClick={() => onOpen(conversation)}
              >
                <span className="dz-history-row-icon">
                  <DeccaIcon name="history" size={16} />
                </span>
                <div className="dz-history-row-body">
                  <div className="dz-history-row-top">
                    <span className="dz-history-row-title">{conversation.Title}</span>
                    <span className="dz-history-row-time">
                      {formatConversationTime(conversation.Timestamp)}
                    </span>
                  </div>
                </div>
                <Tooltip content="Gesprek verwijderen" left="-100px" top="-50px" width="25px">
                  <button
                    className="dz-ib dz-ib-sm dz-ib-danger dz-reveal"
                    aria-label="Gesprek verwijderen"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(conversation);
                    }}
                  >
                    <DeccaIcon name="trash" size={14} />
                  </button>
                </Tooltip>
              </div>
            ))}
          </div>
        ))}

        {groups.length === 0 && (
          <div className="dz-history-empty">Geen gesprekken gevonden.</div>
        )}
      </div>
    </div>
  );
};

export default History;
